export enum ProplantaStatus {
  EDITING = 'editing',
  WAITING_FOR_FINALIZATION = 'waitingForFinalization',
  FINALIZED = 'finalized',
  NEED_YEARLY_DATA = 'needYearlyData',
  PARCEL_NOT_FINALIZED = 'parcelNotFinalized'
}
